import type { EvidenceItem } from "@/types/content";

export const evidenceItems: EvidenceItem[] = [
  {
    id: "ev-01",
    claim: "「原始截图的拍摄时间就是 5 月 11 日晚」",
    category: "时间",
    sourceA: {
      name: "首帖附带截图",
      detail: "界面元素显示的日期为 5 月 11 日，但截图边缘被裁切，缺失完整状态栏。",
      level: "D 级 · 无法溯源",
    },
    sourceB: {
      name: "读者提供的原始文件",
      detail: "完整元信息显示拍摄时间区间落在 5 月 11 日 19:40—20:10 之间。",
      level: "A 级 · 一手材料",
    },
    verdict: "基本一致",
    confidence: 88,
    note: "两份材料的时间落在同一晚，与首帖发布时间并不冲突，可以保留该说法。",
  },
  {
    id: "ev-02",
    claim: "「事件发生地点已确认」",
    category: "地点",
    sourceA: {
      name: "长文来源 A",
      detail: "描述地点位于城北一带，并给出模糊的地标描述，无图像佐证。",
      level: "C 级 · 二手整理",
    },
    sourceB: {
      name: "来源组 B 表述",
      detail: "描述地点位于城南，与来源 A 相距较远，同样未提供可核验材料。",
      level: "C 级 · 二手整理",
    },
    verdict: "存在矛盾",
    confidence: 24,
    note: "两组说法无法同时成立，且都缺少一手材料，暂不作为定论，维持存疑。",
  },
  {
    id: "ev-03",
    claim: "「流传的关联人物为某某」",
    category: "身份",
    sourceA: {
      name: "早期转发帖",
      detail: "直接点名关联人物，但未说明判断依据。",
      level: "D 级 · 无法溯源",
    },
    sourceB: {
      name: "公开活动记录比对",
      detail: "两个同名个体被混为一谈，其中一人的公开行程与所述时间完全不重合。",
      level: "B 级 · 直接转述",
    },
    verdict: "已排除",
    confidence: 92,
    note: "确认为同名误认，相关说法已从传播条目中撤下并注明原因。",
  },
  {
    id: "ev-04",
    claim: "「关键细节是在现场被补充的」",
    category: "细节",
    sourceA: {
      name: "长文补充帖",
      detail: "称掌握了更多现场细节，但给出的描述与原始截图内容并不吻合。",
      level: "C 级 · 二手整理",
    },
    sourceB: {
      name: "群聊转发记录",
      detail: "还原了细节被加入的时间点，证明部分描述是在转发环节新增的。",
      level: "B 级 · 直接转述",
    },
    verdict: "部分推翻",
    confidence: 61,
    note: "可以确认部分细节源于转发加工，但仍有少量描述无法归因，保留待证。",
  },
  {
    id: "ev-05",
    claim: "「首帖是整件事最早的公开节点」",
    category: "来源",
    sourceA: {
      name: "平台帖子存档",
      detail: "该帖发布时间是当前可回查到的最早公开记录。",
      level: "A 级 · 一手材料",
    },
    sourceB: {
      name: "网页快照时间戳",
      detail: "快照记录的时间与帖子发布时间一致，可互相印证。",
      level: "A 级 · 一手材料",
    },
    verdict: "一致",
    confidence: 90,
    note: "两份可核验材料互相印证，可作为时间线起点，但不排除更早的非公开流转。",
  },
  {
    id: "ev-06",
    claim: "「截图中的界面样式早于声称时间就已存在」",
    category: "技术",
    sourceA: {
      name: "质疑用户对比说明",
      detail: "给出版本差异截图，指出该界面样式上线时间晚于截图声称时间。",
      level: "B 级 · 直接转述",
    },
    sourceB: {
      name: "原始文件版本信息",
      detail: "文件元信息显示其生成版本支持该界面样式，与质疑说法相反。",
      level: "A 级 · 一手材料",
    },
    verdict: "已推翻",
    confidence: 85,
    note: "原始文件版本信息可核验，此前的界面时间矛盾说法不成立，条目已更正。",
  },
];